import React, { memo } from "react";
import { MessageThreadFragment } from "gql/graphql";
import colors from "app/colors";
import { Text, HStack, VStack, Divider } from "@chakra-ui/react";
import { HappycoMiniLogoIcon } from "modules/icons";
import Link from "modules/layouts/_shared/link";

interface IProps {
  messageThread: MessageThreadFragment;
}

const HappycoWorkOrderMessageThreadDrawerDetails = ({
  messageThread,
}: IProps) => {
  const happycoWorkOrder = messageThread.happycoWorkOrder;

  if (!happycoWorkOrder) {
    return null;
  }

  return (
    <VStack w="full" alignItems="flex-start">
      <HStack>
        <HappycoMiniLogoIcon boxSize={6} fill={colors.blackSecondary} />
        <Text
          fontFamily="Outfit"
          fontSize={18}
          fontWeight={600}
          color={colors.blackSecondary}
        >
          HappyCo Task
        </Text>
      </HStack>
      <Divider borderColor={colors.black} />
      <VStack w="full" alignItems="flex-start" spacing={0}>
        <Text fontSize={14} fontWeight={600} color={colors.blackSecondary}>
          This thread was created from a task in HappyCo.
        </Text>
        {happycoWorkOrder.happycoUrl && (
          <Link
            href={happycoWorkOrder.happycoUrl}
            target="_blank"
            color={colors.blue}
            fontSize={12}
            fontWeight={600}
          >
            View Full Task Details
          </Link>
        )}
      </VStack>
    </VStack>
  );
};

export default memo(HappycoWorkOrderMessageThreadDrawerDetails);
